import { render, staticRenderFns } from "./DetailContext.vue?vue&type=template&id=5443ae12&scoped=true&"
import script from "./DetailContext.vue?vue&type=script&lang=js&"
export * from "./DetailContext.vue?vue&type=script&lang=js&"
import style0 from "./DetailContext.vue?vue&type=style&index=0&id=5443ae12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5443ae12",
  null
  
)

export default component.exports